import goods from '@/components/goods';
import { batchQuerySimpleItemInfoPost } from '@/api';
import { env } from '@/config';

export default {
  components: { goods },
  props: {
    componentId: String,
    props: {
      type: Object,
      default: () => ({
        list: []
      })
    },
  },
  data() {
    return {
      goodsList: []
    };
  },
  computed: {
    propsComponentId() {
      return this.componentId || this.props?.componentId
    },
    clickGoodsCode() {
      return this.props.clickGoodsCode
    }
  },
  watch: {
    'props.list': {
      handler (val) {
        this.init();
        this.getGoodsList(val); 
        },
      deep: true
    }
  },
  mounted() {
    this.init();
    this.$nextTick(() => {
      this.getGoodsList(this.props.list);
    });
  },
  methods: {
    init() {
      // 占位渲染
      const goodsList = [];

      this.props.list.forEach((val) => goodsList.push({queryId:val.itemCode}));
      this.goodsList = goodsList;
    },
    async getGoodsList(list) {
      // const itemCodeList = ['1774c5022c01736', '205dbcf80800539', '1d35b5da9000736', '1367fef23c01872'];
      
      const itemCodeList = [];
      list.forEach(item => {
        if (env === 'mock' || item.itemCode) itemCodeList.push(item.itemCode);
      });

      if (!itemCodeList.length) {
        // this.goodsList = [];
        return;
      }

      const params = { itemCodeList };
      try {
        const res = await batchQuerySimpleItemInfoPost(params)
        if (!this.isInKaer) {
          this.goodsList = this.goodsList.map((item) => {
            const existItem = res.find((listObj) => listObj.itemCode == item.queryId);
              return { ...item, ...existItem };
          });
        } else {
          this.goodsList = res;
        }
        this.uploadTelescope();
      } catch (error) {
        console.log(error);
      }
    },
    uploadTelescope() {
      const list = [];
      this.goodsList.forEach(item => {
        if (item.itemCode) list.push({ itemCode: item.itemCode });
      });
      this.uploadData(this.trackId, 'event', { list, kaerComponentId: this.componentId });
    }
  }
};
